import ExportDropDown from "@/components/ExportDropDown.vue";
import AppIcon from "@/components/AppIcon";
import CSVIcon from "@/components/icons/CSVIcon.vue";
import AppDropdownItem from "@/components/AppDropdownItem.vue";
import { EVENTS } from "@/utils";
export default {
  name: "PricingAndMarginExportDropDown",
  emits: ["download-content-csv"],
  components: {
    ExportDropDown,
    AppIcon,
    CSVIcon,
    AppDropdownItem
  },
  data() {
    return {
      export_options: [{
        value: "pricing_margin_content",
        text: "Export Pricing and Margin",
        sub_category: "pricing_margin_content",
        icon: "CSVIcon",
        track_event: "userExportedPricingAndMarginContentCSV"
      }],
      export_options_categories: ["pricing_margin_content"]
    };
  },
  props: {
    isDownloadRunning: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async handleDownload(download_option) {
      //console.log("[handle download clicked]");
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: download_option.track_event,
        properties: {}
      });
      this.$emit("download-content-csv", download_option.value);
    }
  }
};